import Heatmap from '@fusioncharts/powercharts/src/chart/heatmap';
export default Heatmap;
